import { Component, OnInit } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { DataTaskService } from '../../../core/services/data-task.service';
import { UtilityService } from '../../../core/services/utility.service';

@Component({
  selector: 'tt-currency-ex-rate',
  templateUrl: './currency-ex-rate.component.html',
  styleUrls: ['./currency-ex-rate.component.css']
})
export class CurrencyExRateComponent implements OnInit {
    currencyExRateKeyno;

    public edit?: Edit;

    public saving = false;

    constructor(private stateService: StateService, private utilityService: UtilityService, private datatask: DataTaskService) {
        this.currencyExRateKeyno = this.stateService.getStateParams()['currencyexrate_keyno'];
    }

    private async loadEdit() {
        if (!!this.currencyExRateKeyno) {
            this.edit = (await this.datatask.Post(1023, { currencyexrate_keyno: this.currencyExRateKeyno }))[0];
        }
    }

    public async saveChanges() {
        if (!!this.edit) {
            try {
                this.saving = true;

                await this.datatask.Post(1024, this.edit);

                this.stateService.back();
            } finally {
                this.saving = false;
            }
        }
    }

    private recalcExchangeRateFactor() {
        if (!!this.edit) {
            this.edit.exchangerate_factor = this.utilityService.parseNumber(this.edit.exchangerate) / this.utilityService.parseNumber(this.edit.valuta_pr);
        }
    }

    public onChanged(_: number, id: keyof Edit) {
        switch (id) {
            case 'exchangerate':
                this.recalcExchangeRateFactor();
                break;
            default:
                break;
        }
    }

    private async init() {
        this.loadEdit();
    }

    ngOnInit() {
        this.init();
    }
}

interface Edit {
    currencyexrate_keyno: number;
    currencytype_keyno: number;
    valuta_id: string;
    exchangerate: number;
    exchangerate_factor: number;
    currency_id: string;
    valuta_pr: number;
    currencytype_name: string;
    exchangerate_info: string;
    nbr_of_history: number;
    changed_by_portal_user_name: string;
    changed_datetime: string;
}

//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('currencyExRate', {
//        templateUrl: 'views/components/views/currencyExRate/currencyExRate.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'utilityService', 'currencyExRateService', function ($stateParams, stateService, utilityService, currencyExRateService) {
//            const vm = this;
//            let currencyExRateKeyno = $stateParams.currencyexrate_keyno;

//            vm.model = {
//                edit: {},
//                lockedSave: false
//            };

//            async function loadEdit() {
//                vm.model.edit = (await currencyExRateService.getEdit({ currencyexrate_keyno: currencyExRateKeyno }))[0];
//            }

//            function recalcExchangeRateFactor() {
//                vm.model.edit.exchangerate_factor = utilityService.parseNumber(vm.model.edit.exchangerate / vm.model.edit.valuta_pr);
//            }

//            vm.saveChanges = function () {
//                vm.model.lockedSave = true;

//                currencyExRateService.saveObj(vm.model.edit).then(() => {
//                    vm.model.lockedSave = false;
//                    stateService.back();
//                }, () => vm.model.lockedSave = false);
//            }

//            vm.onExchangerateChanged = function (value) {
//                vm.model.edit.exchangerate = value;

//                if (value) {
//                    recalcExchangeRateFactor();
//                }
//            }

//            vm.$onInit = function () {
//                loadEdit();
//            }
//        }]
//    });
//})();
